'use client';

import * as React from 'react';
import Image from 'next/image';
import styles from './styles.module.scss';
import Link from 'next/link';
import SmartLink from '@/components/ui/SmartLink';

export type IHeaderLink = {
  href: string;
  label: React.ReactNode;
  target?: string;
  openInNewTab?: boolean;
  showModal?: boolean;
};

export interface IHeaderProps {
  siteName: string;
  logoDesktop?: {
    width: number;
    height: number;
    src: string;
  };
  logoMobile?: {
    width: number;
    height: number;
    src: string;
  };
  links: IHeaderLink[];
  tickets?: React.ReactNode;
  buttons?: React.ReactNode;
}

const Header: React.FunctionComponent<IHeaderProps> = (props) => {

  return (
    <div className={styles['header']}>
      <div className={styles['header__row-1']}>
        <div className={styles['header__limiter']}>
          {(!!props.logoDesktop || props.logoMobile) && (
            <div className={styles['header__logo']}>
              <Link href="/">
                {!!props.logoDesktop && (
                  <Image
                    alt={props.siteName}
                    src={props.logoDesktop.src}
                    width={props.logoDesktop.width}
                    height={props.logoDesktop.height}
                    className={styles['header__logo__desktop']}
                  />
                )}
                {!!props.logoMobile && (
                  <Image
                    alt={props.siteName}
                    src={props.logoMobile.src}
                    width={props.logoMobile.width}
                    height={props.logoMobile.height}
                    className={styles['header__logo__mobile']}
                  />
                )}
              </Link>
            </div>
          )}
          {props.tickets}
          {props.buttons}
        </div>
      </div>
      {props.links && props.links.length > 0 && (
        <div className={styles['header__row-2']}>
          <div className={styles['header__limiter']}>
            <ul className={styles['header__links']}>
              {props.links.map((link, linkIndex) => (
                <li key={linkIndex}>
                  <SmartLink
                    link={link}
                    useActiveLink={true}
                    exact={true}
                  >
                    {link.label}
                  </SmartLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

Header.displayName = 'Header';

export default Header;
